import script from "./CreditMetricCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditMetricCard.vue?vue&type=script&setup=true&lang=js"

import "./CreditMetricCard.vue?vue&type=style&index=0&id=5dd31335&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd31335"]])

export default __exports__